<template>
  <div class="video-wrapper" :class="{ active: pauseVideo }">
    <div class="video-container">
      <video
        playsinline
        ref="search-item"
        @timeupdate="runSeekSlider"
        class="video"
        :src="`${data.url}#t=0.5`"
      >
        <!-- <track
          label="English"
          kind="subtitles"
          srclang="en"
          :src="data.cc"
          default
        /> -->
      </video>
      <div
        class="seek-tooltip"
        id="seek-tooltip"
        ref="seek-tooltip"
        v-show="showVideoTooltip"
      >
        <img ref="search-item-thumbnail" class="video-thumbnail" />
        <div class="tooltip-time" ref="tooltip-time"></div>
      </div>
      <div class="controls-buttons">
        <div
          class="button-wrapper button-wrapper-nt"
          :class="{ active: ifNT }"
          @click="onNTChange"
        >
          <span class="button-text">NT</span>
        </div>
        <div class="button-wrapper share" @click="ifSharing = !ifSharing">
          <Share />
        </div>
      </div>
      <div class="controls-buttons-sharing" v-if="ifSharing">
        <div
          class="controls-buttons-sharing-item controls-buttons-sharing-item--facebook"
          @click="shareFacebook"
        >
          <Facebook />
        </div>
        <div
          class="controls-buttons-sharing-item controls-buttons-sharing-item--twitter"
          @click="shareTwitter"
        >
          <Twitter />
        </div>
        <div
          class="controls-buttons-sharing-item controls-buttons-sharing-item--mail"
        >
          <a href="mailto:mail@example.org"><Mail /></a>
        </div>
        <div
          class="controls-buttons-sharing-item controls-buttons-sharing-item--copy"
          @click="copyLink"
        >
          <Copy /><span v-if="ifCopied" class="copy-text">Copied</span>
        </div>
        <!-- <div class="controls-buttons-sharing-item"><Link /></div> -->
      </div>
      <div class="spotlights">
        <span
          v-for="(i, index) in spotlights"
          @click.prevent="runToExactTime(i.time_code_start)"
          :key="index"
          v-if="validSpotlights.includes(i)"
          class="wrapper-spotlight"
        >
          <Property1 v-if="i === 'odometer'" />
          <Property5 v-if="i === 'wheel'" />
          <Property6 v-if="i === 'headlight'" />
          <Property4 v-if="i === 'tire'" />
          <Property2 v-if="i === 'navigation'" />
          <Property3 v-if="i === 'trunk'" />
        </span>
      </div>
    </div>
    <div v-if="!pauseVideo" @click="playVideo" class="play-button">
      <Play />
    </div>
    <div class="players-controls-wrapper flex align-center">
      <div class="players-controls flex align-center">
        <button
          id="playpausebtn"
          @click.prevent="playVideo"
          :class="{ pause: pauseVideo }"
        ></button>
        <div class="next" @click="rewindVideo"><Next /></div>
        <div id="video_controls_bar">
          <div class="controls-wrapper">
            <input
              id="seekslider"
              ref="seekslider"
              type="range"
              min="0"
              max="100"
              value="0"
              step="1"
              @change="runToMinute"
              @mousemove="showTooltip"
              @mouseleave="hideTooltip"
            />
            <span id="curtimetext" ref="curtimetext">00:00</span
            ><span ref="durtimetext" id="durtimetext">00:00</span>
          </div>
        </div>
        <div class="cc-wrapper"><CC /></div>
        <div class="mute" @click="muteVideo"><Mute :mute="muted" /></div>
        <div class="full-video" @click="fullVideo"><FullScreen /></div>
      </div>
    </div>

    <div class="section-button-wrapper" :class="{ active: ifNT }">
      <div class="button-item" @click="changeType(1)">
        HD Videos({{ videos_length }})
      </div>
      <div class="button-item" @click="changeType(2)">360 Spin</div>
      <div class="button-item" @click="changeType(3)">
        Photos({{ images_length }})
      </div>
    </div>
    <div class="section-nt-block" :class="{ active: ifNT }">
      <div class="marquee">
        <span
          >Based on 2018 EPA mileage ratings. Use for comparison purposes
          only</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import Property1 from "../components/icons/Property1.vue";
import Property2 from "../components/icons/Property2.vue";
import Property3 from "../components/icons/Property3.vue";
import Property4 from "../components/icons/Property4.vue";
import Property5 from "../components/icons/Property5.vue";
import Property6 from "../components/icons/Property6.vue";
import Mute from "../components/icons/Mute.vue";
import FullScreen from "../components/icons/FullScreen.vue";
import Play from "../components/icons/Play.vue";
import Share from "../components/icons/Share.vue";
import Next from "../components/icons/Next.vue";
import Copy from "../components/icons/Copy.vue";
import Facebook from "../components/icons/Facebook.vue";
import Link from "../components/icons/Link.vue";
import Mail from "../components/icons/Mail.vue";
import Twitter from "../components/icons/Twitter.vue";
import CC from "../components/icons/CC.vue";
export default {
  name: "Video",
  props: [
    "data",
    "spotlights",
    "play",
    "videos_length",
    "images_length",
    "index"
  ],
  components: {
    Property1,
    Property2,
    Property3,
    Property4,
    Property5,
    Property6,
    Mute,
    FullScreen,
    Play,
    Share,
    Next,
    Copy,
    Link,
    Facebook,
    Twitter,
    Mail,
    CC
  },
  watch: {
    play: function(value) {
      if (value) {
        this.playVideo();
      } else {
        this.stopVideo();
      }
    }
  },
  data: function() {
    return {
      validSpotlights: [
        "odometer",
        "wheel",
        "headlight",
        "tire",
        "navigation",
        "trunk"
      ],
      muted: false,
      pauseVideo: false,
      preload: "auto",
      video: undefined,
      videoIsLoaded: false,
      showVideoTooltip: false,
      ifNT: false,
      ifSharing: false,
      ifCopied: false,
      vtt_data: []
    };
  },
  mounted() {
    this.video = this.$refs["search-item"];
    if (this.video) {
      this.video.addEventListener(
        "error",
        () => {
          this.$emit("onError");
        },
        true
      );
    }
    this.vtt_data = this.getVttFile(this.data.thumbnails);
  },
  computed: {
    vtt() {
      let data = this.vtt_data;
      const processedVtts = [];
      const vttDefinitions = data.split(/[\r\n][\r\n]/i);

      vttDefinitions.forEach(vttDef => {
        if (
          vttDef.match(
            /([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?( ?--> ?)([0-9]{2}:)?([0-9]{2}:)?[0-9]{2}(.[0-9]{3})?[\r\n]{1}.*/gi
          )
        ) {
          const vttDefSplit = vttDef.split(/[\r\n]/i);
          const vttTiming = vttDefSplit[0];
          const vttTimingSplit = vttTiming.split(/ ?--> ?/i);
          const vttTimeStart = vttTimingSplit[0];
          const vttTimeEnd = vttTimingSplit[1];
          const vttImageDef = vttDefSplit[1];

          processedVtts.push({
            start: this.getSecondsFromTimestamp(vttTimeStart),
            end: this.getSecondsFromTimestamp(vttTimeEnd),
            img: vttImageDef
          });
        }
      });

      return processedVtts;
    }
  },
  methods: {
    deconstructTimestamp(timestamp) {
      const splitStampMilliseconds = timestamp.split(".");
      const timeParts = splitStampMilliseconds[0];
      const timePartsSplit = timeParts.split(":");

      return {
        milliseconds: parseInt(splitStampMilliseconds[1], 10) || 0,
        seconds: parseInt(timePartsSplit.pop(), 10) || 0,
        minutes: parseInt(timePartsSplit.pop(), 10) || 0,
        hours: parseInt(timePartsSplit.pop(), 10) || 0
      };
    },
    getSecondsFromTimestamp(timestamp) {
      const timestampParts = this.deconstructTimestamp(timestamp);

      return parseInt(
        timestampParts.hours * (60 * 60) +
          timestampParts.minutes * 60 +
          timestampParts.seconds +
          timestampParts.milliseconds / 1000,
        10
      );
    },
    getImgForTime(time) {
      for (let i = 0; i < this.vtt.length; ++i) {
        let item = this.vtt[i];
        if (time >= item.start && time < item.end) {
          return item.img;
        }
      }
    },
    getVttFile(url) {
      let main = this;
      let req = new XMLHttpRequest();
      req.onload = function() {
        if (req.readyState === req.DONE) {
          main.vtt_data = req.response;
        }
      };
      req.open("GET", url);
      req.overrideMimeType("text/plain; charset=utf-8");
      req.send();
    },
    copyLink() {
      this.ifCopied = true;
      let input = document.createElement("textarea");
      input.innerHTML = this.$refs["search-item"].src;
      document.body.appendChild(input);
      input.select();
      let result = document.execCommand("copy");
      document.body.removeChild(input);
      setTimeout(() => {
        this.ifCopied = false;
      }, 2000);
      return result;
    },
    shareFacebook() {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${this.$refs["search-item"].src}`,
        "_blank"
      );
    },
    shareTwitter() {
      window.open(
        `https://www.twitter.com/share?url=${this.$refs["search-item"].src}`,
        "_blank"
      );
    },
    onNTChange() {
      this.ifNT = !this.ifNT;
      this.$emit("onNTChange", this.ifNT);
    },
    showTooltip(event) {
      if (!this.pauseVideo) {
        return;
      }
      this.showVideoTooltip = true;

      const seekTooltip = this.$refs["seek-tooltip"];
      const skipTo = Math.round(
        (event.offsetX / event.target.clientWidth) *
          parseInt(event.target.getAttribute("max"), 10)
      );

      this.$refs["search-item-thumbnail"].src = this.getImgForTime(
        Math.floor((this.video.duration * skipTo) / 100)
      );

      const tooltipTime = this.$refs["tooltip-time"];
      let curmins = Math.floor(
        Math.floor((this.video.duration * skipTo) / 100) / 60
      );
      let cursecs = Math.floor(
        Math.floor((this.video.duration * skipTo) / 100) - curmins * 60
      );
      if (cursecs < 10) {
        cursecs = "0" + cursecs;
      }
      if (curmins < 10) {
        curmins = "0" + curmins;
      }
      tooltipTime.textContent = `${curmins}:${cursecs}`;
      const rect = this.video.getBoundingClientRect();
      seekTooltip.style.left = `${event.pageX - rect.left - 60}px`;
    },

    hideTooltip() {
      this.showVideoTooltip = false;
    },
    changeType(type) {
      this.$emit("changeType", type);
    },
    runToMinute(e) {
      e.preventDefault();
      const video = this.$refs["search-item"];
      if (video && video.readyState === 4) {
        video.currentTime = Math.floor(
          this.$refs["search-item"].duration *
            (this.$refs["seekslider"].value / 100)
        );
      }
    },
    runSeekSlider() {
      if (this.video && this.video.readyState === 4) {
        if (this.video.currentTime) this.videoIsLoaded = true;
        const curtimetext = this.$refs["curtimetext"];
        const durtimetext = this.$refs["durtimetext"];
        if (this.$refs["seekslider"])
          this.$refs["seekslider"].value =
            this.video.currentTime * (100 / this.video.duration);
        let curmins = Math.floor(this.video.currentTime / 60);
        let cursecs = Math.floor(this.video.currentTime - curmins * 60);
        let durmins = Math.floor(this.video.duration / 60);
        let dursecs = Math.floor(this.video.duration - durmins * 60);
        if (cursecs < 10) {
          cursecs = "0" + cursecs;
        }
        if (dursecs < 10) {
          dursecs = "0" + dursecs;
        }
        if (curmins < 10) {
          curmins = "0" + curmins;
        }
        if (durmins < 10) {
          durmins = "0" + durmins;
        }
        if (curtimetext) curtimetext.innerHTML = curmins + ":" + cursecs;
        if (durtimetext) durtimetext.innerHTML = durmins + ":" + dursecs;
      }
    },
    rewindVideo() {
      if (this.video && this.video.readyState === 4) {
        this.video.currentTime = this.video.currentTime + 10;
        this.video.play();
      }
    },
    runToExactTime(time) {
      if (this.video && this.video.readyState === 4) {
        this.video.currentTime = time;
        this.video.play();
      }
    },
    muteVideo() {
      if (this.video.muted) {
        this.muted = false;
        this.video.muted = false;
      } else {
        this.video.muted = true;
        this.muted = true;
      }
    },
    playVideo() {
      const isPlaying =
        this.video.currentTime > 0 &&
        !this.video.paused &&
        !this.video.ended &&
        this.video.readyState > 2;

      if (!isPlaying) {
        this.pauseVideo = true;
        this.video.play();
        this.$emit("onPlay", true);
      } else {
        this.pauseVideo = false;
        this.video.pause();
        this.$emit("onPlay", false);
      }
    },
    stopVideo() {
      this.video.pause();
      this.pauseVideo = false;
    },
    fullVideo() {
      if (this.video && this.video.readyState === 4) {
        if (this.video.requestFullScreen) {
          this.video.requestFullScreen();
        } else if (this.video.webkitEnterFullscreen) {
          this.video.webkitEnterFullscreen();
        } else if (this.video.webkitRequestFullScreen) {
          this.video.webkitRequestFullScreen();
        } else if (this.video.mozRequestFullScreen) {
          this.video.mozRequestFullScreen();
        }
      }
    }
  }
};
</script>

<style>
.seek-tooltip {
  position: absolute;
  bottom: 115px;
  width: 142px;
  height: 105px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.2),
      rgba(255, 255, 255, 0.2)
    ),
    rgba(69, 67, 84, 0.3);
  border: 0.9px solid rgba(255, 255, 255, 0.6);
}
.video-thumbnail {
  object-fit: cover;
  width: 140px;
  height: 83px;
  border-radius: 4px;
  overflow: hidden;
}
.tooltip-time {
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 11px;
  line-height: 13px;
  letter-spacing: 0.01em;
  text-transform: uppercase;
  color: #ffffff;
  padding: 5px 0;
}
#seekslider:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Video.vue